(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-results-matrix';
  var GRID_SELECTOR = '[data-oddit-count-up]';
  var VALUE_SELECTOR = '.oddit-section-results-matrix__stat-value';
  var DURATION = 1200;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function isThemeEditor() {
    return (
      typeof window.Shopify !== 'undefined' &&
      window.Shopify.designMode === true
    );
  }

  function parse(text) {
    var match = text.match(/-?\d+(?:[.,]\d+)?/);
    if (!match) {
      return null;
    }

    var raw = match[0];
    var normalized = raw.replace(',', '.');
    var point = normalized.indexOf('.');

    return {
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + raw.length),
      target: parseFloat(normalized),
      decimals: point === -1 ? 0 : normalized.length - point - 1,
      separator: raw.indexOf(',') === -1 ? '.' : ','
    };
  }

  function format(parts, value) {
    var body = value.toFixed(parts.decimals);
    if (parts.separator === ',') {
      body = body.replace('.', ',');
    }
    return parts.prefix + body + parts.suffix;
  }

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function count(el) {
    if (el.hasAttribute('data-oddit-counted')) {
      return;
    }
    el.setAttribute('data-oddit-counted', '');

    var parts = parse(el.textContent.trim());
    if (!parts || !isFinite(parts.target)) {
      return;
    }

    var start = null;

    function step(now) {
      if (start === null) {
        start = now;
      }

      var progress = Math.min((now - start) / DURATION, 1);
      if (progress < 1) {
        el.textContent = format(parts, parts.target * easeOut(progress));
        requestAnimationFrame(step);
      } else {
        el.textContent = format(parts, parts.target);
      }
    }

    requestAnimationFrame(step);
  }

  function ensureObserver() {
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              count(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      );
    }
    return observer;
  }

  function init(root) {
    if (reducedMotion.matches || isThemeEditor()) {
      return;
    }

    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
      grid.querySelectorAll(VALUE_SELECTOR).forEach(function (el) {
        ensureObserver().observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector(SECTION_SELECTOR)) {
      init(event.target);
    }
  });
})();
